const getters = {
  genders (state) {
    return state.genders
  },
  targetDevices (state) {
    return state.targetDevices
  },
  ageGroups (state) {
    return state.ageGroups
  },
  advertisingChannels (state) {
    return state.advertisingChannels
  },
  objectives (state) {
    return state.objectives
  },
  types (state) {
    return state.types
  },
  campaignCategories (state) {
    return state.campaignCategories
  },
  budgetActionTypes (state) {
    return state.budgetActionTypes
  },
  defaultAdsetObject (state) {
    return state.defaultAdsetObject
  },
  rejectReviewReasons (state) {
    return state.rejectReviewReasons
  },
  holdReviewReasons (state) {
    return state.holdReviewReasons
  },
  defaultAdObject (state) {
    return state.defaultAdObject
  },
  pixelEvents (state) {
    return state.pixelEvents
  },
  deletedCampaign (state) {
    return state.deletedCampaign
  },
  loggedInAccountCampaigns (state) {
    return state.loggedInAccountCampaigns
  },
  targetingLookups (state) {
    return state.targeting_lookups
  }
}

export default getters
